var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReminder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,2H14V.5a.5.5,0,0,0-1,0V2H7V.5a.5.5,0,0,0-1,0V2H3A2,2,0,0,0,1,4V14a2,2,0,0,0,2,2H8.5a.5.5,0,0,0,0-1H3a1,1,0,0,1-1-1V6H18V7.5a.5.5,0,0,0,1,0V4A2,2,0,0,0,17,2ZM2,5V4A1,1,0,0,1,3,3H6v.5a.5.5,0,0,0,1,0V3h6v.5a.5.5,0,0,0,1,0V3h3a1,1,0,0,1,1,1V5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.781,17.344,19,15V12a4,4,0,0,0-8,0v3l-.782,2.346a.5.5,0,0,0,.471.654H13a2,2,0,0,0,4,0h2.308A.5.5,0,0,0,19.781,17.344ZM15,19a1,1,0,0,1-1-1h2A1,1,0,0,1,15,19Zm-3.613-2,.562-1.684A1,1,0,0,0,12,15V12a3,3,0,0,1,6,0v3a1,1,0,0,0,.051.316L18.613,17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminder);
export default __webpack_public_path__ + "static/media/Reminder.f39f19799540639a2e3420fdf0f68412.svg";
export { ForwardRef as ReactComponent };